/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation, useQuery } from 'react-query';

import {
  acceptInvitation,
  checkInvitationToken,
  CheckInvitationTokenRes,
  confirmInvitationEmail,
} from '~/api/invitation';

export const useCheckInvitationToken = (
  token: string | undefined,
  options: { onSuccess?(res: CheckInvitationTokenRes): void; onError?: (error: any) => void } = {}
) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useQuery(['invitation', token, 'check'], () => checkInvitationToken(token!), {
    enabled: !!token,
    staleTime: Infinity,
    ...options,
  });
};

export const useConfirmInvitationEmail = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token') as string;
  return useMutation(() => confirmInvitationEmail(token));
};

export const useAcceptInvitation = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token') as string;
  return useMutation(() => acceptInvitation(token), { onError() {} });
};
